export const FLASHCARDS = [
  {
    "id": 1,
    "topic_id": 4,
    "title": "What are the three goals of cybersecurity?",
    "description": "Confidentiality, integrity, and availability."
  },
  {
    "id": 2,
    "topic_id": 1,
    "title": "What are the three goals of an attacker?",
    "description": "Disclosure, alteration, and denial."
  },
  {
    "id": 3,
    "topic_id": 4,
    "title": "What activity seeks to evaluate the security controls of an organization by actually attacking the organization?",
    "description": "Penetration testing."
  },
  {
    "id": 4,
    "topic_id": 4,
    "title": "What activity seeks to scour an organization for signs of a successful compromise?",
    "description": "Threat hunting."
  },
  {
    "id": 5,
    "topic_id": 1,
    "title": "How often does PCI DSS require that organizations perform external penetration testing?",
    "description": "At least annually and after any significant application or infrastructure upgrade or modification."
  },
  {
    "id": 6,
    "topic_id": 3,
    "title": "What are the four stages of a penetration test, according to CompTIA?",
    "description": "1.Planning and scoping."
  },
  {
    "id": 7,
    "topic_id": 5,
    "title": "What are the seven stages of the Cyber Kill Chain?",
    "description": "1.Reconnaissance."
  },
  {
    "id": 8,
    "topic_id": 4,
    "title": "What are some common credential testing tools?",
    "description": "Hashcat, Medusa, Hydra, CeWL, John the Ripper, Cain and Abel, Mimikatz, Patator, DirBuster, W3AF."
  },
  {
    "id": 9,
    "topic_id": 2,
    "title": "What are some common debuggers?",
    "description": "OllyDbg, Immunity Debugger, GDB, WinDbg, IDA."
  },
  {
    "id": 10,
    "topic_id": 1,
    "title": "What function does the Burp Suite fulfill?",
    "description": "Interception proxy."
  },
  {
    "id": 11,
    "topic_id": 2,
    "title": "What is an SOW and what does it cover?",
    "description": "A statement of work describes what work will be done as part of a specific engagement."
  },
  {
    "id": 12,
    "topic_id": 3,
    "title": "What is an MSA and what does it cover?",
    "description": "A master services agreement covers the overall contractual terms for ongoing work between two organizations."
  },
  {
    "id": 13,
    "topic_id": 4,
    "title": "What is an NDA?",
    "description": "A nondisclosure agreement."
  },
  {
    "id": 14,
    "topic_id": 4,
    "title": "What do the rules of engagement for a penetration test include?",
    "description": "Timeline, locations, systems, applications and other target information, data handling requirements, expected target behaviors, resources, legal concerns, and communications."
  },
  {
    "id": 15,
    "topic_id": 4,
    "title": "What term is used to describe what happens when a pentest client adds additional systems, applications, or networks not covered in the original agreement?",
    "description": "Scope creep."
  },
  {
    "id": 16,
    "topic_id": 4,
    "title": "Name a search engine that provides port scans and vulnerability data.",
    "description": "Shodan or Censys."
  },
  {
    "id": 17,
    "topic_id": 3,
    "title": "What does the term OSINT stand for?",
    "description": "Open source intelligence, or information that is gathered passively rather than actively."
  },
  {
    "id": 18,
    "topic_id": 4,
    "title": "What organization provides CAPEC and CVE?",
    "description": "MITRE."
  },
  {
    "id": 19,
    "topic_id": 2,
    "title": "What is the information is built into files like image files, PDFs, and Microsoft Office documents and describes the document, authors, creation times, and other similar details called?",
    "description": "Metadata."
  },
  {
    "id": 20,
    "topic_id": 2,
    "title": "What type of DNS transaction is used to replicate DNS databases between servers?",
    "description": "A zone transfer."
  },
  {
    "id": 21,
    "topic_id": 2,
    "title": "What range of ports is known as the \u201cwell known\u201d or \u201csystem\u201d ports?",
    "description": "0\u20131023."
  },
  {
    "id": 22,
    "topic_id": 2,
    "title": "Name the ports for the following services: SSH, SNMP, and Microsoft SQL.",
    "description": "In order: 22 (SSH), 161 and 162 (SNMP), 1433 and 1434 (MS-SQL)."
  },
  {
    "id": 23,
    "topic_id": 2,
    "title": "How does operating system fingerprinting work?",
    "description": "It uses TCP/IP stack fingerprinting techniques that focus on responses to TCP and UDP packets sent to remote hosts and comparing them with known patterns."
  },
  {
    "id": 24,
    "topic_id": 2,
    "title": "What do the following Nmap flags mean? -sV, -O, -T5",
    "description": "These flags will detect the service version (-sV) and the operating system (-O) and will use a very fast aggressive timing (-T5)."
  },
  {
    "id": 25,
    "topic_id": 1,
    "title": "What criteria should be used to determine vulnerability scan targets?",
    "description": "Data classification, system exposure, services offered, and test/production/development status."
  },
  {
    "id": 26,
    "topic_id": 1,
    "title": "What term is used to describe an organization\u2019s willingness to tolerate risk?",
    "description": "Risk appetite."
  },
  {
    "id": 27,
    "topic_id": 3,
    "title": "What type of account should be used to perform credentialed vulnerability scans?",
    "description": "Read-only account."
  },
  {
    "id": 28,
    "topic_id": 3,
    "title": "What are the names of common network vulnerability scanning tools?",
    "description": "Nessus, Qualys, and OpenVAS."
  },
  {
    "id": 29,
    "topic_id": 3,
    "title": "What are the names of common web application scanning tools?",
    "description": "Nikto and Wapiti."
  },
  {
    "id": 30,
    "topic_id": 1,
    "title": "What criteria should be used in prioritizing the remediation of vulnerabilities?",
    "description": "Criticality, difficulty, severity, and exposure."
  },
  {
    "id": 31,
    "topic_id": 1,
    "title": "What are the CVSS base score ranges?",
    "description": "Under CVSS v3, 0.0 is none, 0.1\u20133.9 is low, 4.0\u20136.9 is medium, 7.0\u20138.9 is high, and 9.0\u201310.0 is critical."
  },
  {
    "id": 32,
    "topic_id": 3,
    "title": "What is the term used to describe when a scanner reports a vulnerability that does not really exist?",
    "description": "False positive."
  },
  {
    "id": 33,
    "topic_id": 3,
    "title": "What type of vulnerability allows an attacker to place more data into an area of memory than is allocated for a specific purpose?",
    "description": "Buffer overflow."
  },
  {
    "id": 34,
    "topic_id": 4,
    "title": "What type of attack seeks to increase the level of access that an attacker has to a targeted system?",
    "description": "Privilege escalation."
  },
  {
    "id": 35,
    "topic_id": 4,
    "title": "What type of attack allows an attacker to run software of their choice on the targeted system?",
    "description": "Arbitrary code execution."
  },
  {
    "id": 36,
    "topic_id": 3,
    "title": "What is the current secure standard for providing HTTPS encryption?",
    "description": "TLS 1.3 or later."
  },
  {
    "id": 37,
    "topic_id": 4,
    "title": "In what type of attack does the attacker sends spoofed DNS requests to a DNS server that are carefully designed to elicit responses that are much larger in size than the original requests?",
    "description": "DNS amplification."
  },
  {
    "id": 38,
    "topic_id": 4,
    "title": "What language is used to interact with relational databases?",
    "description": "Structured Query Language (SQL)."
  },
  {
    "id": 39,
    "topic_id": 4,
    "title": "In what type of attack does the attacker embed on a website scripting commands that will later be executed by an unsuspecting visitor accessing the site?",
    "description": "Cross-site scripting (XSS)."
  },
  {
    "id": 40,
    "topic_id": 4,
    "title": "What component of a virtualization platform resides between the guest operating systems and physical hardware?",
    "description": "Hypervisor."
  },
  {
    "id": 41,
    "topic_id": 3,
    "title": "What metrics do penetration testers often use to determine which services to attempt to exploit?",
    "description": "Severity of the vulnerability, quality of detection, availability of the exploit, and danger of secondary effects like potential system crashes."
  },
  {
    "id": 42,
    "topic_id": 2,
    "title": "Name two exploit databases.",
    "description": "The Exploit Database, the Rapid 7 Vulnerability and Exploit Database, the National Vulnerability Database, and VulDB."
  },
  {
    "id": 43,
    "topic_id": 4,
    "title": "What term describes the use of multiple exploits to gain information, privileges, or access?",
    "description": "Exploit chaining."
  },
  {
    "id": 44,
    "topic_id": 4,
    "title": "What is Metasploit\u2019s default payload?",
    "description": "Meterpreter."
  },
  {
    "id": 45,
    "topic_id": 5,
    "title": "What is the Linux tool for scheduling tasks?",
    "description": "cron."
  },
  {
    "id": 46,
    "topic_id": 4,
    "title": "What condition does Responder have to meet to successfully acquire credentials?",
    "description": "It has to respond to the target faster than the legitimate server."
  },
  {
    "id": 47,
    "topic_id": 4,
    "title": "Rank the following tools in order from fastest to slowest under most circumstances: John the Ripper, RainbowCrack, Hashcat",
    "description": "1.RainbowCrack."
  },
  {
    "id": 48,
    "topic_id": 4,
    "title": "What is the most popular tool for post-exploitation acquisition of Windows password hashes?",
    "description": "Mimikatz."
  },
  {
    "id": 49,
    "topic_id": 4,
    "title": "What term describes a cloned wireless access point?",
    "description": "An evil twin."
  },
  {
    "id": 50,
    "topic_id": 4,
    "title": "Name two VLAN hopping attack methods.",
    "description": "Double tagging, switch spoofing."
  },
  {
    "id": 51,
    "topic_id": 2,
    "title": "How can defenders identify an SSH proxy from the local host it is running on?",
    "description": "Check the list of running processes."
  },
  {
    "id": 52,
    "topic_id": 4,
    "title": "What technique is frequently used to conduct on-path attacks on local networks?",
    "description": "ARP spoofing."
  },
  {
    "id": 53,
    "topic_id": 4,
    "title": "What replay attack is used with NTLM hashes?",
    "description": "Pass-the-hash attacks."
  },
  {
    "id": 54,
    "topic_id": 4,
    "title": "What makes a relay attack different from a replay attack?",
    "description": "Relay attacks only repeat traffic without modifying it."
  },
  {
    "id": 55,
    "topic_id": 4,
    "title": "Name three major types of denial-of-service attacks.",
    "description": "Application layer attacks aimed at crashing a service or server, protocol-based attacks aimed at protocol flaws, attacks based on traffic volume."
  },
  {
    "id": 56,
    "topic_id": 4,
    "title": "What common tool allows the creation of arbitrary packets?",
    "description": "hping."
  },
  {
    "id": 57,
    "topic_id": 4,
    "title": "What type of phishing targets specific individuals?",
    "description": "Spear phishing."
  },
  {
    "id": 58,
    "topic_id": 4,
    "title": "What is term for voice phishing?",
    "description": "Vishing."
  },
  {
    "id": 59,
    "topic_id": 4,
    "title": "What type of phishing targets VIPs?",
    "description": "Whaling."
  },
  {
    "id": 60,
    "topic_id": 3,
    "title": "What technique is sometimes used when penetration testers cannot gain physical or network access to a facility but need to have applications run on local workstations?",
    "description": "A USB drop key."
  },
  {
    "id": 61,
    "topic_id": 4,
    "title": "What is shoulder surfing?",
    "description": "Observing a target entering a password or other information, often over their shoulder."
  },
  {
    "id": 62,
    "topic_id": 3,
    "title": "What physical entry technique can be defeated by a security vestibule (mantrap)?",
    "description": "Piggybacking or tailgating."
  },
  {
    "id": 63,
    "topic_id": 4,
    "title": "Name two social engineering pentesting tools.",
    "description": "SET, the Social Engineering toolkit."
  },
  {
    "id": 64,
    "topic_id": 4,
    "title": "Which social engineering motivation technique relies on making the target believe you have the right to ask them to perform an action?",
    "description": "Authority."
  },
  {
    "id": 65,
    "topic_id": 4,
    "title": "Name three social engineering motivation techniques.",
    "description": "Authority, scarcity, social proof, urgency, likeness, fear."
  },
  {
    "id": 66,
    "topic_id": 4,
    "title": "What are the two forms of input validation?",
    "description": "Whitelisting and blacklisting."
  },
  {
    "id": 67,
    "topic_id": 4,
    "title": "What technology can be used to sit in front of a web server and filter out malicious content at the application layer?",
    "description": "Web application firewall (WAF)."
  },
  {
    "id": 68,
    "topic_id": 4,
    "title": "What are the two forms of blind SQL injection?",
    "description": "Boolean blind SQL injection and blind timing-based SQL injection."
  },
  {
    "id": 69,
    "topic_id": 4,
    "title": "What system call is commonly exploited in Linux command injection attacks?",
    "description": "system()."
  },
  {
    "id": 70,
    "topic_id": 4,
    "title": "What object is normally stolen during a session hijacking attack?",
    "description": "Authentication cookie."
  },
  {
    "id": 71,
    "topic_id": 4,
    "title": "What component of a Kerberos system handles user authentication?",
    "description": "Authentication server (AS)."
  },
  {
    "id": 72,
    "topic_id": 4,
    "title": "What web application attack is characterized by the use of an integer identifier in a query string?",
    "description": "Insecure direct object references."
  },
  {
    "id": 73,
    "topic_id": 4,
    "title": "What web application attack is characterized by the use of double periods (..) in a query string?",
    "description": "Directory traversal."
  },
  {
    "id": 74,
    "topic_id": 4,
    "title": "What web application attack is characterized by the use of a local filesystem path in a query string?",
    "description": "Local file inclusion."
  },
  {
    "id": 75,
    "topic_id": 4,
    "title": "What attack is an example of exploiting a race condition?",
    "description": "Time-of-check-to-time-of-use (TOC/TOU) attack."
  },
  {
    "id": 76,
    "topic_id": 4,
    "title": "What Linux setting tells Linux that an executable file should be run as the owner of the file, not the user who launched it?",
    "description": "The SUID (set user ID) bit."
  },
  {
    "id": 77,
    "topic_id": 4,
    "title": "What limitations are commonly associated with restricted shells?",
    "description": "The inability to change directories, to specify PATH or SHELL variables, and to specify absolute pathnames or to redirect output."
  },
  {
    "id": 78,
    "topic_id": 2,
    "title": "What is the first step in most kerberoasting attacks?",
    "description": "Scanning Active Directory for user accounts with service principal names (SPNs) set."
  },
  {
    "id": 79,
    "topic_id": 4,
    "title": "Where are local Windows password hashes stored on Windows desktop operating systems?",
    "description": "The Windows SAM or Security Account Manager."
  },
  {
    "id": 80,
    "topic_id": 2,
    "title": "What filename extension is normally used for Bash scripts?",
    "description": ".sh."
  },
  {
    "id": 81,
    "topic_id": 4,
    "title": "What filename extension is normally used for PowerShell scripts?",
    "description": ".ps1."
  },
  {
    "id": 82,
    "topic_id": 4,
    "title": "What filename extension is normally used for Python scripts?",
    "description": ".py."
  },
  {
    "id": 83,
    "topic_id": 4,
    "title": "What filename extension is normally used for Ruby scripts?",
    "description": ".rb."
  },
  {
    "id": 84,
    "topic_id": 2,
    "title": "What languages are described as command shell scripting languages?",
    "description": "Bash and PowerShell."
  },
  {
    "id": 85,
    "topic_id": 2,
    "title": "What languages use the -eq operator to test equality?",
    "description": "Bash and PowerShell."
  },
  {
    "id": 86,
    "topic_id": 4,
    "title": "What command is used to send output directly over a network connection?",
    "description": "nc."
  },
  {
    "id": 87,
    "topic_id": 1,
    "title": "What are the common triggers for immediate communication to management?",
    "description": "Completion of a testing stage, discovery of a critical finding, and discovery of indicators of prior compromise."
  },
  {
    "id": 88,
    "topic_id": 1,
    "title": "Who should be involved when conducting goal prioritization during a penetration test?",
    "description": "All relevant stakeholders."
  },
  {
    "id": 89,
    "topic_id": 1,
    "title": "What are the three main categories of remediation strategy?",
    "description": "People, process, and technology."
  },
  {
    "id": 90,
    "topic_id": 1,
    "title": "What is the suggested remediation strategy for shared local administrator credentials?",
    "description": "Randomizing passwords of administrator accounts and use of a password manager."
  },
  {
    "id": 91,
    "topic_id": 1,
    "title": "What is the suggested remediation strategy for weak password complexity?",
    "description": "Strong password complexity requirements."
  },
  {
    "id": 92,
    "topic_id": 1,
    "title": "What is the suggested remediation strategy for plaintext passwords?",
    "description": "Storing passwords in hashed or encrypted form."
  },
  {
    "id": 93,
    "topic_id": 4,
    "title": "What are the main categories of authentication factors?",
    "description": "Something you know, something you have, and something you are."
  },
  {
    "id": 94,
    "topic_id": 1,
    "title": "What is the suggested remediation strategy for SQL injection?",
    "description": "Sanitizing user input and parameterized queries."
  },
  {
    "id": 95,
    "topic_id": 1,
    "title": "What is the suggested remediation strategy for unnecessary open services?",
    "description": "System hardening."
  },
  {
    "id": 96,
    "topic_id": 1,
    "title": "What are the major sections of a penetration testing report?",
    "description": "Executive summary, scope details, methodology, findings and remediations, conclusion, and appendix."
  },
  {
    "id": 97,
    "topic_id": 4,
    "title": "What pentesting tool is specifically designed to use IPv6 to exploit IPv4 networks by conducting a DNS attack?",
    "description": "mitm6."
  },
  {
    "id": 98,
    "topic_id": 2,
    "title": "What is TruffleHog used to search?",
    "description": "Git repositories."
  },
  {
    "id": 99,
    "topic_id": 2,
    "title": "What type of environment would you use CrackMapExec in, and what is its primary use?",
    "description": "It is used to live off the land in Active Directory environments, particularly large AD networks."
  },
  {
    "id": 100,
    "topic_id": 4,
    "title": "Which two of the following four tools are designed primarily for auditing and compliance checking? Scout Suite, Cloud Brute, Pacu, Cloud Custodian",
    "description": "Cloud Custodian and Scout Suite are designed for auditing and compliance checking."
  },
  {
    "id": 101,
    "topic_id": 4,
    "title": "Name three special considerations that pentesters should keep in mind when assessing IoT devices",
    "description": "Fragile environments, availability concerns, data corruption issues, data exfiltration requirements and challenges."
  },
  {
    "id": 102,
    "topic_id": 3,
    "title": "What can you assume if you discover a vulnerability in an application in a containerized environment with multiple instances of the same application running?",
    "description": "The same vulnerability will likely appear on all instances of the application in the pool."
  },
  {
    "id": 103,
    "topic_id": 3,
    "title": "What major patching issue can penetration testers often leverage due to the variety of Android versions and vendors?",
    "description": "Patching fragmentation is an issue because multiple vendors provide their own versions and updates for Android devices."
  },
  {
    "id": 104,
    "topic_id": 3,
    "title": "What type of physical attack is most likely to be used against an RFID reader that does not use certificates?",
    "description": "A badge cloning attack."
  },
  {
    "id": 105,
    "topic_id": 3,
    "title": "Name four vulnerabilities related to mobile devices",
    "description": "Insecure storage, passcode vulnerabilities, certificate pinning, using known vulnerable components, dependency vulnerabilities, patching fragmentation, execution of activities using root, over-reach of permissions, biometrics integration, business logic vulnerabilities."
  },
  {
    "id": 106,
    "topic_id": 4,
    "title": "What type of attack is most likely to result in a resource exhaustion issue for cloud-hosted systems?",
    "description": "A distributed denial-of-service attack."
  },
  {
    "id": 107,
    "topic_id": 4,
    "title": "List two common cloud misconfiguration issues.",
    "description": "Identity and access management misconfigurations, federation misconfigurations, object storage misconfigurations, containerization technology misconfigurations."
  },
  {
    "id": 108,
    "topic_id": 4,
    "title": "What types of attacks is an evil twin most likely to be used for?",
    "description": "An on-path attack, a data modification or corruption attack, or a relay attack."
  },
  {
    "id": 109,
    "topic_id": 200,
    "title": "Know how the CIA and DAD triads describe the goals of cybersecurity professionals and attackers.",
    "description": "Cybersecurity professionals strive to protect the confidentiality, integrity, and availability of information and systems. Attackers seek to undermine these goals by achieving the goals of disclosure, alteration, and denial."
  },
  {
    "id": 110,
    "topic_id": 200,
    "title": "Be able to name several important benefits of penetration testing.",
    "description": "Penetration testing provides knowledge about an organization's security posture that can't be obtained elsewhere. It also provides a blueprint for the remediation of security issues. Finally, penetration tests provide focused information on specific attack targets."
  },
  {
    "id": 111,
    "topic_id": 200,
    "title": "Understand that penetration testing may be conducted to meet regulatory requirements.",
    "description": "The Payment Card Industry Data Security Standard (PCI DSS) requires that organizations involved in the processing of credit card transactions conduct both internal and external penetration tests on an annual basis."
  },
  {
    "id": 112,
    "topic_id": 200,
    "title": "Describe how both internal and external teams may conduct penetration tests.",
    "description": "Internal teams have the benefit of inside knowledge about the environment. They also operate more cost\u2010effectively than external teams. External penetration testers have the benefit of organizational independence from the teams who designed and implemented the security controls."
  },
  {
    "id": 113,
    "topic_id": 200,
    "title": "Know the five phases of the penetration testing process.",
    "description": "Penetration testers begin in the Engagement Management phase, where they develop a statement of work and agree with the client on rules of engagement. They then move into reconnaissance efforts during the Reconnaissance and Enumeration phase. The information collected is then used to discover vulnerabilities in the Vulnerability Discovery and Analysis phase and conduct attacks during the Attacks and Exploits phase. After the final phase, Post\u2010exploitation and Lateral Movement, the team shares its findings with the target organization."
  },
  {
    "id": 114,
    "topic_id": 200,
    "title": "Describe the tools used by penetration testers.",
    "description": "Tools designed for use by cybersecurity professionals and other technologists may also assist penetration testers in gathering information and conducting attacks. Penetration testers use specialized exploitation frameworks, such as Metasploit, to help automate their work."
  },
  {
    "id": 115,
    "topic_id": 200,
    "title": "Be able to explain the importance of planning and scoping engagements.",
    "description": "Planning a penetration test requires understanding why the test is being conducted and who the target audience of the closeout report is. While the penetration test is being planned, important elements include the rules of engagement, communications and emergency escalation plans, requirements like confidentiality and resource availability, the overall budget for the assessment, and any technical or business constraints that are in place. The rules of engagement are one of the most critical parts of this planning and usually include the scope: what can and cannot be tested."
  },
  {
    "id": 116,
    "topic_id": 200,
    "title": "Be able to apply appropriate standards and methodologies.",
    "description": "Openly available penetration testing standards like the Open Source Security Testing Methodology Manual (OSSTM), the Penetration Testing Execution Standard (PTES), and the Information System Security Assessment Framework (ISSAF) can serve as a strong foundation for penetration testing practices. Specialized knowledge like the web and application\u2010specific testing methodologies and techniques provided by the Open Worldwide Application Security Project (OWASP) or the technique and method mapping provided by MITRE's ATT&CK framework give penetration testers more tools to build better testing techniques and processes. Finally, NIST 800\u2010115 and other standards set expectations about what a test should include."
  },
  {
    "id": 117,
    "topic_id": 200,
    "title": "Know the importance of the rules of engagement for penetration testing and how to validate the scope of the engagement. A critical part of penetration testing preparation is to set the rules of engagement.",
    "description": "Penetration testers need to determine if the test will be a known, partially known, or unknown environment. They must also determine if there are specific times of day or dates, systems or environments, or other limitations to what should be considered in scope. Testers also need to work out contract details and how they will manage their own time to ensure that they are meeting the requirements in an effective way."
  },
  {
    "id": 118,
    "topic_id": 200,
    "title": "Understand target selection and what assets may be considered in scope.",
    "description": "Target selection determines how much effort will be required to complete an assessment, how complex the assessment will be, and whether you will need third\u2010party involvement or permissions to test systems that are not directly owned by the target of the penetration test. In known environment assessments, target selection is usually much simpler. An unknown environment assessment can make target selection much more difficult and should be carefully scoped and defined to ensure that only legitimate targets are tested."
  },
  {
    "id": 119,
    "topic_id": 200,
    "title": "Understand the key legal concepts related to penetration testing.",
    "description": "Penetration testers need to understand legal concepts like master service agreements that define the overall contract between organizations for engagements, statements of work that define the deliverables for those engagements, and nondisclosure agreements that protect the data and information involved in a penetration test. You must also be aware of the legal and regulatory environment in which both you and your target operate so that your testing process and tools are legal. Finally, it's critical to ensure that appropriate legal agreements, with approvals from proper signing authorities, are in place so that you are covered in the event of something going wrong."
  },
  {
    "id": 120,
    "topic_id": 200,
    "title": "Be able to explain the issues, objectives, and caveats that you may encounter when conducting compliance\u2010based assessments.",
    "description": "Compliance, in the form of laws, regulations, and industry standards, drives many penetration tests. Understanding regulations like GDPR that have specific requirements you may need to meet as part of your testing process will help you better complete compliance assessments. Standards like PCI DSS that require compliance from credit card merchants provide clearly defined objectives but also have specific rules that may influence both how you conduct your assessment and the rules of engagement for the overall test."
  },
  {
    "id": 121,
    "topic_id": 200,
    "title": "Understand passive reconnaissance.",
    "description": "Passive information gathering is performed entirely without interacting with the organization or its systems and relies on third\u2010party information sources. These include using DNS lookups and social media scraping, searching for information like password and data dumps and breach information, reviewing corporate information, and using passive reconnaissance search engines like Shodan and Censys as part of their normal efforts. Information about an organization's domains, IP ranges, software, employees, finances, and technologies, and many other useful elements of information can be gathered as part of an OSINT effort."
  },
  {
    "id": 122,
    "topic_id": 200,
    "title": "Know the purpose of reconnaissance exercises.",
    "description": "Enumeration of users, email addresses, URLs, shares, and services, as well as groups, relationships, applications, and many other types of data, provides further information for pentesters. Enumeration provides a list of potential targets for testing, social engineering, or other techniques. Pentesters should know the basic concepts and techniques commonly used for enumeration as well as the tools that are most frequently used for each type of enumeration."
  },
  {
    "id": 123,
    "topic_id": 200,
    "title": "Be familiar with the steps involved in active reconnaissance.",
    "description": "Once open source information about an organization has been gathered and networks and hosts that will be targeted have been identified, active reconnaissance begins. Active reconnaissance involves direct interactions with target systems and services and is intended to gather information that will allow pentesters to target attacks effectively. Port scans, version scans, and other interactive assessment techniques are used to gather information in this phase of a penetration test. Testers should be very familiar with tools like Nmap, including any specific flags and scan capabilities. Active reconnaissance may include the need to identify defenses, determine if third\u2010party or cloud\u2010hosted systems may be included in infrastructure or target lists, and learn how to avoid detection."
  },
  {
    "id": 124,
    "topic_id": 200,
    "title": "Be able to describe the purpose of information gathering and code review.",
    "description": "Applications, code, tokens, and application interfaces are all legitimate targets in penetration tests, and understanding how to gather information about applications through code analysis, debugging, and decompilation can be important when you encounter them. Although knowing how to decompile an application and read every line of code isn't in scope, understanding the basics of how to read source code, how to find useful information in compiled code, and what techniques exist for pentesters to work with both compiled and interpreted code is important. Pentesters must also know how tokens are used and the basic concepts behind how tokens could be exploited as part of a penetration test."
  },
  {
    "id": 125,
    "topic_id": 200,
    "title": "Vulnerability scans automate some of the tedious work of penetration testing.",
    "description": "Automated vulnerability scanners allow penetration testers to rapidly check large numbers of systems for the presence of known vulnerabilities. Although this greatly speeds up the work of a penetration tester, the scan may also attract attention from cybersecurity professionals."
  },
  {
    "id": 126,
    "topic_id": 200,
    "title": "Scan targets should be selected based on the results of discovery scans.",
    "description": "Discovery scans provide penetration testers with an automated way to identify hosts that exist on the network and build an asset inventory. They may then select scan targets based on the likelihood that it will advance the goals of the penetration test. This may include information about data classification, system exposure, services offered, and the status of the system as a test, development, or production environment. Discovery scans may use a combination of TCP scans, UDP scans, and/or stealth scans to identify systems present on the network."
  },
  {
    "id": 127,
    "topic_id": 200,
    "title": "Configuring scan settings allows customization to meet the tester's requirements.",
    "description": "Penetration testers may customize scans by configuring the sensitivity level, including and excluding plug\u2010ins, and supplementing basic network scans with information gathered from authenticated and unauthenticated scans as well as network\u2010based and host\u2010based scans. Teams may also conduct scans from more than one scan perspective, providing different views of the network."
  },
  {
    "id": 128,
    "topic_id": 200,
    "title": "Vulnerability scanners require maintenance like any other technology tool.",
    "description": "Administrators responsible for maintaining vulnerability scanning systems should perform two important administrative tasks. First, they should update the scanner software on a regular basis to correct security issues and add new functionality. Second, they should update plug\u2010ins frequently to provide the most accurate and up\u2010to\u2010date vulnerability scans of their environment."
  },
  {
    "id": 129,
    "topic_id": 200,
    "title": "Organizations should use a consistent remediation workflow to identify, remediate, and test vulnerabilities.",
    "description": "Remediation workflows should be as automated as possible and integrate with other workflow technology used by the IT organization. As technologists correct vulnerabilities, they should validate that the remediation was effective through security testing and close out the vulnerability in the tracking system. Penetration test SOWs should carefully define how and when vulnerabilities detected during tests are fed into the organization's remediation workflow."
  },
  {
    "id": 130,
    "topic_id": 200,
    "title": "Penetration testers must be prepared to overcome objections to scanning from other members of the IT team.",
    "description": "Common objections to vulnerability scanning include the effect that service degradation caused by scanning will have on IT services, commitments to customers in MOUs and SLAs, and the use of IT governance and change management processes."
  },
  {
    "id": 131,
    "topic_id": 200,
    "title": "Penetration testers use a variety of tools to discover vulnerabilities.",
    "description": "Nessus is a popular commercial network vulnerability scanning tool. Greenbone OpenVAS is an open source alternative that also performs network vulnerability scanning. Nikto is a tool that specializes in scanning web applications, while Trivy specializes in scanning containerized systems."
  },
  {
    "id": 132,
    "topic_id": 200,
    "title": "Be able to explain how vulnerability scan reports provide critical information to penetration testers.",
    "description": "In addition to providing details about the vulnerabilities present on a system, vulnerability scan reports also offer crucial severity and exploitation information. The report typically includes the request and response that triggered a vulnerability report as well as a suggested solution to the problem."
  },
  {
    "id": 133,
    "topic_id": 200,
    "title": "Know the purpose of the Common Vulnerability Scoring System (CVSS).",
    "description": "The CVSS base score computes a standard measure on a 10\u2010point scale that incorporates information about the attack vector required to exploit a vulnerability, the complexity of the exploit, the attack requirements, the privileges required, and the level of user interaction required to execute an attack. The base score also considers the impact of the vulnerability on the confidentiality, integrity, and availability of the vulnerable system and subsequent systems."
  },
  {
    "id": 134,
    "topic_id": 200,
    "title": "Understand the different results possible from a vulnerability scan.",
    "description": "When a scan correctly reports that a vulnerability exists, that is known as a true positive report. When a scan detects a vulnerability that does not exist, this is a false positive report. When a scan correctly reports that a vulnerability does not exist, that is known as a true negative report. When a scan does not report a vulnerability but one does exist, that is a false negative report."
  },
  {
    "id": 135,
    "topic_id": 200,
    "title": "Be able to name common sources of vulnerability.",
    "description": "Missing patches and outdated operating systems are two of the most common vulnerability sources and are easily corrected by proactive device maintenance. Buffer overflow, privilege escalation, and arbitrary code execution attacks typically exploit application flaws. Devices supporting insecure protocols are also a common source of vulnerabilities."
  },
  {
    "id": 136,
    "topic_id": 200,
    "title": "Know that network devices should receive regular firmware updates.",
    "description": "Network administrators should ensure that network devices receive regular firmware updates to patch security issues. Improper implementations of SSL and TLS encryption also cause vulnerabilities when they use outdated protocols, insecure ciphers, or invalid certificates."
  },
  {
    "id": 137,
    "topic_id": 200,
    "title": "Be able to explain how virtualized infrastructures add another layer of potential vulnerability.",
    "description": "Administrators responsible for virtualized infrastructure must take extra care to ensure that the hypervisor is patched and protected against virtual machine escape attacks. Additionally, administrators should carefully restrict access to the virtual infrastructure's management interface to prevent unauthorized access attempts."
  },
  {
    "id": 138,
    "topic_id": 200,
    "title": "Understand post\u2010exploitation tools and techniques.",
    "description": "Pentesters need to know how to use tools like Empire, Mimikatz, and BloodHound to continue their exploits. These tools can allow lateral movement to other accounts and systems with similar privilege levels and access, including the use of pass\u2010the\u2010hash techniques. They can also help with privilege escalation horizontally by gaining access to similar accounts, or through vertical escalation to more powerful accounts like administrator accounts."
  },
  {
    "id": 139,
    "topic_id": 200,
    "title": "Explain enumeration techniques.",
    "description": "Enumerating new targets is an important task for pentesters who gain access to their targets. Common enumeration targets included in the PenTest+ exam outline include users, groups, forests, sensitive data, and unencrypted data. Pentesters need to know the basics of how these can be enumerated and why each is an important target."
  },
  {
    "id": 140,
    "topic_id": 200,
    "title": "Explain how to create a foothold and maintain persistence.",
    "description": "Once you have access to a system, you need to create and maintain a foothold. That means using tools that can provide remote access like Trojans and backdoors that provide remote shell access. Other techniques like the use of daemons that run automatically at system startup and schedule tasks that put remote access back in place on a scheduled basis are also important for pentesters to be aware of. Knowing when each of these techniques is suited for a task and what benefits and limitations each has are important to be prepared for the exam."
  },
  {
    "id": 141,
    "topic_id": 200,
    "title": "Demonstrate how to avoid detection.",
    "description": "Detection avoidance techniques include the use of fileless malware that does not leave files or artifacts on the remote system and instead injects itself into running processes. Once you've gained access to a system, the next step is living off the land, which means using built\u2010in tools available on target systems instead of bringing tools along. Once access has been obtained, pentesters need to consider methods and tools for data exfiltration, including what techniques like the use of steganography and covert channels are best suited to different scenarios. Finally, covering your tracks involves cleaning up tools and data and ensuring that defenders have a harder time detecting or reverse\u2010engineering attacks."
  },
  {
    "id": 142,
    "topic_id": 200,
    "title": "Understand how common penetration testing tools are used in a test.",
    "description": "Pentesters need to be familiar with a broad range of tools. The PenTest+ exam outline specifically mentions SearchSploit, PowerSploit, Responder, the Impacket tools suite, Empire, Metasploit, mitm6, CrackMapExec, TruffleHog, and Censys as examples of tools that you should be aware of for the exam."
  },
  {
    "id": 143,
    "topic_id": 200,
    "title": "Understand and be able to explain common network\u2010based attack methods.",
    "description": "Explain what eavesdropping and on\u2010path attacks are, how they can be implemented, and what challenges exist for pentesters who want to capture traffic. Describe relay attacks and spoofing, how they're related and how they differ. Understand data modification and data corruption attacks. Implement handshake and hash capturing attacks. Explain why jamming might be used by a pentester to accomplish other attacks."
  },
  {
    "id": 144,
    "topic_id": 200,
    "title": "Describe network attacks.",
    "description": "You should be able to explain multiple types of NAC bypass scenarios, including MAC spoofing, DHCP server\u2010based NAC controls, and how SNMP and ARP detection can be attacked. Describe and explain VLAN hopping, trunking, and related techniques to view traffic that is not native to your VLAN or to send traffic to other VLANs. Explain Kerberoasting, DNS cache poisoning, LLMNR and NBT\u2010NS poisoning, as well as NTLM relay attacks. Know how to implement a basic load\u2010based stress test as part of a pentester's efforts."
  },
  {
    "id": 145,
    "topic_id": 200,
    "title": "Use wireless and RF\u2010based exploits and attacks.",
    "description": "Wireless attacks require a few techniques that go beyond those required for wired networks. Know how to set up an evil twin access point using Aircrack\u2010ng and be familiar with the steps necessary to deauthenticate a target system. Explain captive portal and WIPS PIN attacks and how they can be used. Be able to describe how and when credential harvesting is possible via a wireless network. In addition, you should have a basic understanding of non\u2010Wi\u2010Fi wireless exploits, including Bluetooth attacks, RFID cloning, and how jamming and repeating traffic can be useful to a pentester."
  },
  {
    "id": 146,
    "topic_id": 200,
    "title": "Explain phishing techniques.",
    "description": "List and explain how to conduct phishing techniques, including spear phishing, SMS phishing, voice phishing, and whaling. Understand common phishing practices and why individuals or specific populations might be targeted versus a large group or an entire organization."
  },
  {
    "id": 147,
    "topic_id": 200,
    "title": "Understand social engineering motivation techniques.",
    "description": "Know when and how to apply common social engineering motivation techniques. Differentiate authority, scarcity, social proof, urgency, likeness, and fear\u2010based approaches and when and why each can be useful. Explain why combining motivation techniques can be beneficial, and which techniques work together well. Describe impersonation attacks and techniques and when you might use them as part of a social engineering effort."
  },
  {
    "id": 148,
    "topic_id": 200,
    "title": "Describe physical security attack methods.",
    "description": "Describe physical facility penetration testing techniques, including how to perform a tailgating attack. Explain dumpster diving, shoulder surfing, and badge cloning and explain when and why you would use each."
  },
  {
    "id": 149,
    "topic_id": 200,
    "title": "Use social engineering tools like SET and BeEF.",
    "description": "Have a basic familiarity with the Social Engineering Toolkit (SET) and how to implement common attacks using it. Understand the basic command structure, what capabilities are included in the tool, and how it integrates with Metasploit to deliver exploit packages. Explain how to set up a browser\u2010based attack with the Browser Exploitation Framework (BeEF), including what information it can capture, what types of exploits it provides, and what limitations may exist in using it in a penetration test."
  },
  {
    "id": 150,
    "topic_id": 200,
    "title": "Know the different types of application scans.",
    "description": "Static application security testing (SAST) tools perform analysis of an application's source code to identify security vulnerabilities without actually executing the code. Dynamic application security testing (DAST) tools execute the code and run it through many different input scenarios in an attempt to find vulnerabilities. Interactive application security testing (IAST) combines elements of both SAST and DAST by instrumenting the application while it runs. Software composition analysis (SCA) focuses on identifying security vulnerabilities within third\u2010party libraries and open source components. Secrets scanning tools automatically search through codebases and configuration files to detect sensitive information, like API keys and passwords, that may have been inadvertently exposed."
  },
  {
    "id": 151,
    "topic_id": 200,
    "title": "Understand how injection vulnerabilities allow attackers to interact with backend systems.",
    "description": "SQL injection vulnerabilities are the most common example, allowing an attacker to exploit a dynamic web application to gain access to the underlying database. The best defense against injection vulnerabilities is to perform rigorous input validation on any user\u2010supplied input."
  },
  {
    "id": 152,
    "topic_id": 200,
    "title": "Know that password authentication techniques contain many insecurities.",
    "description": "Passwords use a weak, knowledge\u2010based approach to authentication and are vulnerable to eavesdropping, phishing, and other means of theft. Multifactor techniques strengthen authentication systems by supplementing password security with either biometric or token\u2010based controls."
  },
  {
    "id": 153,
    "topic_id": 200,
    "title": "Explain how session hijacking attacks exploit vulnerable cookies.",
    "description": "Attackers who are able to obtain the session cookie used to authenticate a user's web session may hijack that session and take control of the user's account. Cookies used for authentication should always be securely generated and transmitted only over secure, encrypted communications channels, such as TLS\u2010protected HTTPS sessions."
  },
  {
    "id": 154,
    "topic_id": 200,
    "title": "Know that web application vulnerabilities are diverse and complex.",
    "description": "Insecure direct object references may allow attackers to bypass authorization schemes and gain access to confidential information by incrementing an object counter or performing similar URL manipulation. Directory traversal attacks allow an attacker to navigate through a web server's filesystem."
  },
  {
    "id": 155,
    "topic_id": 200,
    "title": "Explain how cross\u2010site scripting and cross\u2010site request forgery exploits allow attackers to hijack legitimate sites.",
    "description": "Cross\u2010site scripting (XSS) attacks inject malicious scripting code in an otherwise legitimate website through the use of persistent/stored content or reflected input. Cross\u2010site request forgery (CSRF) attacks exploit the likelihood that users are simultaneously logged into multiple websites and use a malicious site to send commands to a legitimate site."
  },
  {
    "id": 156,
    "topic_id": 200,
    "title": "Understand the role of interception proxies in web application testing.",
    "description": "Interception proxies intercept and manipulate traffic between the client and server, allowing penetration testers to explore vulnerabilities like injection flaws, authentication issues, and insecure configurations. Burp Suite offers a comprehensive suite of tools, including a scanner, intruder, and repeater, making it a versatile choice for security testing. ZAP, an open source alternative, provides similar capabilities and is particularly popular in the security community for its flexibility and ease of use."
  },
  {
    "id": 157,
    "topic_id": 200,
    "title": "Leverage scanning tools to identify web application vulnerabilities.",
    "description": "Gobuster and DirBuster are directory and file busting tools used to find unadvertised files, directories, and subdomains that could expose sensitive information. WPScan specializes in identifying vulnerabilities in WordPress installations, including outdated plugins and themes. Wfuzz is a versatile fuzzer used for brute\u2010forcing web application parameters, making it a powerful tool for finding hidden content and security weaknesses."
  },
  {
    "id": 158,
    "topic_id": 200,
    "title": "Understand the importance of specialized tools for API and secrets security.",
    "description": "Postman is primarily used for testing and interacting with APIs, making it easier to identify security issues in API endpoints. sqlmap automates the process of detecting and exploiting SQL injection vulnerabilities in web applications, providing a powerful means of testing database security. TruffleHog is a secrets scanning tool that searches for sensitive information, such as API keys and credentials, in code repositories, helping to prevent accidental exposure of critical data."
  },
  {
    "id": 159,
    "topic_id": 200,
    "title": "Understand cloud technology attacks and tools.",
    "description": "Attacks against cloud technologies include credential harvesting, privilege escalation, and account takeovers. Misconfigurations are one of the most common ways to gain access to accounts, systems, services, or data. Misconfigured identity and access management is a key flaw to exploit, but misconfigurations in object storage, containerization technologies, and federation misconfiguration can also be leveraged as part of a penetration test. You can obtain data via metadata service attacks and exploits and side\u2010channel attacks, and you can conduct denial\u2010of\u2010service attacks, including bypassing scaling and denial\u2010of\u2010service protections by using direct\u2010to\u2010origin attack techniques. Finally, you'll need to consider cloud software development kits (SDKs) that provide direct interfaces via APIs to cloud services, allowing you to write scripts and programs to help your penetration tests succeed."
  },
  {
    "id": 160,
    "topic_id": 200,
    "title": "Explain storage, management, IoT, and SCADA/ICS vulnerabilities and their uses in a penetration test.",
    "description": "Infrastructure systems like storage devices and services can contain a wealth of useful information. Misconfigurations that expose data are a key way to access storage systems, but compromising storage servers and controllers or gaining access using user credentials are also common ways in. Management interfaces are used to control server hardware and can provide significant control over systems that use them. Although these interfaces are typically placed on isolated VLANs, pentesters may still be able to gain access or to find management interfaces that aren't properly secured. Internet of Things devices often suffer from a lack of patching and security and may provide pentesters with viable targets that provide access to networks or information that they can use. Finally, industrial control systems (ICSs), SCADA, and industrial Internet of Things devices are used to manage factories, utilities, and a wide range of other industrial devices. They require special care when testing due to the potential for harm to business processes and other infrastructure if they are disrupted."
  },
  {
    "id": 161,
    "topic_id": 200,
    "title": "Explain mobile device attacks, vulnerabilities, and tools.",
    "description": "Understand mobile device attacks, including reverse engineering applications and mobile operating systems. Explain what sandbox analysis is and when you'd use it. Leverage spamming techniques as part of mobile device attacks to gain credentials or conduct social engineering exploits. Describe vulnerabilities in mobile devices and applications, including use of insecure storage, attacks against authentication and authorization like biometrics integrations, passcode vulnerabilities, and overly broad permissions. Leverage flaws in known vulnerable components like dependencies or patching issues due to fragmentation of operating systems. Explain the basic functionality and uses of tools like Burp Suite, Drozer, MobSF, Postman, Ettercap, Frida and Objection, the Android SDK tools, APKX, and APK Studio."
  },
  {
    "id": 162,
    "topic_id": 200,
    "title": "Use common techniques to allow remote access.",
    "description": "Know common commands and tools that allow remote access via SSH, Netcat, and Ncat. Explain why, when, and how you can use proxies and proxychains to conceal attack traffic and to allow pivoting inside a secure network via compromised systems."
  },
  {
    "id": 163,
    "topic_id": 200,
    "title": "Understand virtual machine and container exploits.",
    "description": "Explain virtual machine and container concepts and the basic differences between them. Understand the concept of virtual machine and container escape techniques. List reasons that VM escape exploits are unlikely to be available during most penetration tests. Describe container escape exploits and scenarios."
  },
  {
    "id": 164,
    "topic_id": 200,
    "title": "Perform credential attacks.",
    "description": "Use offline credential cracking tools, and understand the differences, basic capabilities, and advantages of each. Create word lists and dictionaries, and explain how they can help with brute\u2010forcing and cracking activities. Be familiar with the uses and purposes of Hashcat, Medusa, Hydra, CeWL, John the Ripper, Cain, Mimikatz, Patator, DirBuster, and w3af."
  },
  {
    "id": 165,
    "topic_id": 200,
    "title": "Know that penetration testers should establish a regular pattern of communication with management.",
    "description": "This communication should include regular meetings where the testers share progress and, when appropriate, interim results. The communication process should also define triggers that may require immediate notification of management. Common communication triggers include the identification of critical findings and the discovery of indications of prior compromise."
  },
  {
    "id": 166,
    "topic_id": 200,
    "title": "Be able to detail what penetration testing reports should include regarding recommended mitigation strategies.",
    "description": "Testers should define remediation strategies that include people, process, and technology controls designed to correct or mitigate the risks discovered during the penetration test. This serves as a road map that management may follow when prioritizing risk remediation activities."
  },
  {
    "id": 167,
    "topic_id": 200,
    "title": "Understand appropriate remediation activities for common findings.",
    "description": "Shared accounts may be remediated through the use of randomized credentials and a local administrator password solution. Weak passwords may be remediated through the use of minimum password requirements and password filters. Plain\u2010text passwords should be encrypted or hashed. Organizations not using multifactor authentication should adopt additional authentication methods. SQL injection vulnerabilities may be remediated through the use of input validation and parameterized queries. Unnecessary open services should be closed as part of system hardening activities."
  },
  {
    "id": 168,
    "topic_id": 200,
    "title": "Be able to describe the purpose of penetration testing reports.",
    "description": "The Executive Summary presents a brief description of the test and its findings. The Methodology section of the report should provide an educated professional with the information necessary to reproduce the test results. The Detailed Findings section provides technical details on the test results as well as recommended mitigation actions. The Attack Narrative section describes how the penetration tester gained access and moved through the system. The Recommendations and Remediation Guidance section offers actionable steps for mitigating identified risks and improving the organization's security posture. The Test Limitations and Assumptions section outlines the constraints and expectations under which the test was conducted, helping to frame the context of the findings. Finally, the report Conclusion ties together the information presented in the report and puts it in the context of the organization's risk appetite. Post\u2010engagement activities ensure that loose ends are tied up."
  },
  {
    "id": 169,
    "topic_id": 200,
    "title": "Conduct post\u2010engagement cleanup.",
    "description": "At the conclusion of a penetration test, testers should conduct post\u2010engagement cleanup to remove traces of their activity. They should ensure that they have formal client acceptance of their results and conduct a lessons learned session."
  },
  {
    "id": 170,
    "topic_id": 200,
    "title": "Explain how shell scripting languages provide basic functionality for automating command\u2010line activities.",
    "description": "These scripting languages are designed for quick\u2010and\u2010dirty activities, such as automating work typically done at a command prompt. The two shell languages that you should be familiar with for the exam are Bash for macOS/Linux systems and PowerShell for Windows systems."
  },
  {
    "id": 171,
    "topic_id": 200,
    "title": "Understand that advanced programming languages raise scripting to the next level.",
    "description": "Python provides developers with fully functional programming languages designed to be able to manipulate complex input and perform just about any possible function. The real power of this language lies in the ability to load modules that contain code written by others."
  },
  {
    "id": 172,
    "topic_id": 200,
    "title": "Understand how variables store values in memory for later use.",
    "description": "All programming languages allow the developer to store data in variables, which may later be accessed programmatically. Depending on the programming language, arrays provide the ability to store multiple elements of the same (or different) data type in a single data structure for ease of reference and manipulation."
  },
  {
    "id": 173,
    "topic_id": 200,
    "title": "Explain how flow control elements allow programmers to structure the logical design of their code.",
    "description": "Conditional execution, using the if..then..else clause, allows developers to test logical conditions before executing code. for loops allow the repetitive execution of code for a specified number of times. while loops continue executing code until a logical condition is no longer true."
  },
  {
    "id": 174,
    "topic_id": 200,
    "title": "Understand how error handling allows the developer to specify code that should execute when an error occurs.",
    "description": "Many security vulnerabilities arise when unhandled errors persist in code. The try..catch clause in most programming languages allows developers to avoid this situation by providing code to handle error conditions explicitly."
  },
  {
    "id": 175,
    "topic_id": 200,
    "title": "Describe how penetration testers use code development skills to analyze exploit code.",
    "description": "When penetration testers encounter exploit code that was used against them or that they intend to use in an attack, they should look for key pieces of evidence that may help them identify the nature of the code. These include enumeration techniques, downloading files, and launching remote access."
  },
  {
    "id": 176,
    "topic_id": 200,
    "title": "Demonstrate how penetration testers may develop software to automate their activities.",
    "description": "Software development helps reduce the tedious nature of penetration testing by automating routine tasks. Key opportunities for automation include modifying the IP addresses targeted by different tools, scanning systems of interest, and performing configuration analysis."
  }
];
